var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    fill: "#283EB4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.25 40.5H34.75C33.6915 40.5 32.8334 41.3581 32.8334 42.4167V53.9167C32.8334 54.9752 33.6915 55.8333 34.75 55.8333H69.25C70.3086 55.8333 71.1667 54.9752 71.1667 53.9167V42.4167C71.1667 41.3581 70.3086 40.5 69.25 40.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5833 55.8333V69.25M42.4167 55.8333V69.25M61.5833 34.75V40.5M42.4167 34.75V40.5M48.1667 55.8333L33.4083 41.075M55.8333 40.5L70.5917 55.2583M44.3333 40.5L59.6667 55.8333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 38,
    fill: "white",
    transform: "translate(31 33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.cf230c728b8cc8843159f55ac086016b.svg";
export { ForwardRef as ReactComponent };